<app-common-page-breadcrumbs [pageTitle]="title" [navigationData]="navigationData"></app-common-page-breadcrumbs>

<div class="bg-light border-bottom" #quotesDetailsPage>
  <div class="container py-4">
    <div class="d-flex justify-content-between">
      <div>
        <a class="text-primary strong bi-cursor-text text-decoration-none" [routerLink]="['/quotes']">
          &lt; {{ "home.quote.Backtolist" | cxTranslate }}</a>
      </div>

      <div class="ml-4" *ngIf="quotesData?.quoteState=='ACCEPTED' && !quotesData?.tenderId && quotesData?.commodityType!=='PO' "
        (click)="downloadDesktopPDF()">
        <a class="semi-bold  text-primary fs-14"> <img src="/images/transaction.svg" alt="customlogo" width="14px"
            height="20px">
          {{'home.quote.Transaction' | cxTranslate }}
        </a>
      </div>
      <div class="mr-3" *ngIf="(quotesData?.quoteState=='OFFER_RECEIVED'|| quotesData?.quoteState=='ACCEPTED') && quotesData?.commodityType=='PO' ">
       <button class="btn btn-primary border pl-5 pr-5 w-100" (click)="downloadDesktopEDRPDF()">
              <i class="far fa-file-alt"></i>&nbsp;&nbsp; {{'home.quote.transactionDetails' | cxTranslate }}
            </button>
      </div>
    </div>
    <!-- <div class='p-0 '>
      <div class="printbtn visible-xs d-none"><span><i class="fas fa-print"></i></span>&nbsp;<span>{{
          'home.quote.Print' | cxTranslate }}</span></div>
      <div class="printbtn d-none"><span><i class="fas fa-print"></i></span>&nbsp;<span>{{
          'home.quote.Exportpdf' | cxTranslate }}</span></div>

    </div> -->
  </div>
</div>
<div *ngIf="enableLoader" id="loader"></div>
<ng-container *ngIf="spinner">
  <div class="overlay"></div>
  <div class="spinner" id="loader" [style.left.px]="left"></div>
</ng-container>
<div *ngIf="quotesData!=undefined && !quotesData.tenderId && quotesData?.commodityType!='PO'">
  <div *ngIf="!enableLoader" class="container ">
    <h3 *ngIf="quotesData?.quoteState == quoteStatusModel?.offerReceived" class="extra-lg-font mb-n4 mt-4">
      {{ 'home.quote.Weare' | cxTranslate }}
    </h3>
    <br *ngIf="quotesData?.quoteState == quoteStatusModel?.offerReceived">
    <div class="desktop-flex justify-content-between mt-2">
      <div class="master">
        <div class="mr-3" [ngClass]="quotesData.c4cCpiSalesOrganization !== undefined?'':'d-none'">
          <span class='small text-secondary'>{{ 'home.quote.Sellername' | cxTranslate }} </span><br>
          <span class="strong">{{quotesData.c4cCpiSalesOrganization !== undefined?quotesData.c4cCpiSalesOrganization:''
            }}</span>
        </div>
        <div class="mr-3" [ngClass]="quotesData.zmasterAgreementSDK !== undefined?'':'d-none'">
          <span class='small text-secondary'>{{ 'home.quote.MasteragreementNo' | cxTranslate }} </span><br>
          <span class="strong">{{quotesData.zmasterAgreementSDK !== undefined?quotesData.zmasterAgreementSDK:''
            }}</span>
        </div>
        <div [ngClass]="quotesData.agreementDate !== undefined?'':'d-none'">
          <span class='small text-secondary'>{{ 'home.quote.Agreementdate' | cxTranslate }} </span><br>
          <span class="strong">{{quotesData.agreementDate !==undefined?convertDate(quotesData.agreementDate):''}}</span>
        </div>
      </div>
      <div class=' p-0 mt-4'>
        <span *ngIf="quotesData?.quoteState == quoteStatusModel?.bidPlaced"> <button class="btn btn-mobile-accept pl-4 pr-4 border1 "
            [disabled]="isPlaceBidDisabled" (click)="openCancelModal(quotesData,'bid')"
            [hidden]="quotesData.c4cQuoteExternalQuoteId?false:true">{{ 'home.quote.Cancelbid'
            | cxTranslate }}</button></span>
        <div class="desktop-flex">
          <div *ngIf="quotesData?.quoteState == quoteStatusModel?.offerReceived" class=""><button
              class="btn btn-primary btn-mobile-accept" [disabled]="isAcceptOfferDisabled"
              (click)="openAcceptModal(quotesData)"> <i class="fa fa-check text-white pr-2" aria-hidden="true"></i>
              {{'home.quote.Acceptoffer' | cxTranslate }} </button>
          </div>
          <div class="space d-flex ml-lg-1">
            <!-- <div *ngIf="quotesData?.quoteState == quoteStatusModel?.offerReceived" class="mr-1 mobile-btn-counter">
              <button class="btn btn-secondary mobile-w-100 fw-bold"
                (click)="openCounterOfferModal(content2 , quotesData)"><img class='pr-2'
                  src="/images/iconCounterOfferWhite.svg" alt=""><a class="anchor-tag text-white">{{
                  'home.quote.Counteroffer' | cxTranslate }}</a></button>
            </div> -->
            <div  *ngIf="quotesData?.quoteState == quoteStatusModel?.offerReceived"> <button
                [disabled]="isPlaceBidDisabled" class="btn btn-secondary btn-mobile-accept left mobile-w-100 fw-bold"
                (click)="openRejectModal(quotesData)">
                <i class="fas fa-times text-white pr-2"></i>{{ 'home.quote.Rejectoffer'
                  |
                  cxTranslate }}</button></div>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div>
      <div>
        <div class="card card-design pb-3 pl-3 pr-3 mb-4 card-border border-radius-05">
          <div class='d-flex justify-content-between'>
            <div class="d-flex align-items-center">
              <span class="bid-status-text" [ngClass]="quotesData.quoteState|quoteStatusStyle">{{
                quotesData?.quoteStatus
                }}
              </span>
              <span id="validty" class="small text-secondary ml-3 visible-xs"
                *ngIf=" quotesData?.quoteStatus == 'Offer received' || quotesData?.quoteStatus == 'Bid placed' && quotesData?.quoteValidity != undefined "
                [ngClass]="quotesData.quoteState == quoteStatusModel.offerReceived?'visible-lg':''">{{
                'home.quote.validity' |
                cxTranslate }}
                {{quotesData?.quoteState ===
                quoteStatusModel.offerReceived?convertDateAndTime(quotesData.offerValidity,quotesData.offerValidityTimeZone):convertDateAndTime(quotesData.quoteValidity,quotesData.quoteValidityTimeZone)}}</span>
              <span class="ml-3 mt-0 text-danger  small"
                *ngIf="quotesData?.quoteState === quoteStatusModel?.offerReceived">
                {{expiryCalculate(quotesData.offerValidity)}} </span>
            </div>
            <div class='d-flex'>
              <span class="small text-secondary visible-xs mr-1">{{ 'home.quote.Id' | cxTranslate
                }}{{quotesData.c4cQuoteExternalQuoteId ? quotesData.c4cQuoteExternalQuoteId:'--'}}</span> &nbsp;
              <span class="small text-secondary visible-xs">
                {{ 'home.quote.Creationdate' | cxTranslate }} {{convertDate(quotesData.creationTime)}}
              </span>
            </div>
          </div>
          <div class="mt-4">
            <div id="offv" class="small text-secondary hidden-xs"
              *ngIf=" quotesData?.quoteStatus == 'Offer received' || quotesData?.quoteStatus == 'Bid placed' && quotesData?.quoteValidity != undefined ">
              {{ 'home.quote.validity' | cxTranslate }} {{quotesData.quoteState ===
              quoteStatusModel.offerReceived?convertDateAndTime(quotesData.offerValidity,quotesData.offerValidityTimeZone):convertDateAndTime(quotesData.quoteValidity,quotesData.quoteValidityTimeZone)}}

            </div>
            <div class="small text-secondary hidden-xs mr-5">{{ 'home.quote.Id' | cxTranslate }}
              {{quotesData.c4cQuoteExternalQuoteId
              ? quotesData.c4cQuoteExternalQuoteId : ' '}}
            </div>
            <div class="small text-secondary hidden-xs"> {{ 'home.quote.Creationdate' | cxTranslate }}
              {{convertDate(quotesData.creationTime)}}
            </div>
          </div>
          <div class="hr"></div>
          <div class="inside-layout" *ngFor="let quote of quotesData.quoteEntries">
            <div class="py-2">
              <div class="h5 mb-0 fw-bold">{{quote?.productName | titlecase }}</div>
              <div class="h5 mb-0 text-secondary"> {{quote?.portName}}</div>
            </div>
            <div class="d-flex py-2 hidden-xs justify-content-between">
              <div class="hidden-xs" [ngClass]="quote.vesselName !== undefined?'':'d-none'">
                <div id="129" class="small text-secondary">{{ 'home.quote.Vesselname' | cxTranslate }}</div>
                <div class="strong"> {{ quote?.vesselName}} </div>
              </div>

              <div class="hidden-xs mr-4 pr-3" [ngClass]="quote.voyageId !== undefined?'':'d-none'">
                <div class="small text-secondary">{{ 'home.quote.Voyage' | cxTranslate }}</div>
                <div class="strong"> {{ quote?.voyageId }} </div>
              </div>
            </div>
            <div class="d-flex hidden-xs justify-content-between py-2">
              <div class="hidden-xs">
                <div class="small text-secondary">{{ 'home.quote.Price(perWMT)' | cxTranslate }} </div>
                <div class="strong"> {{ quote?.price | currency: "RMB ":"symbol":"1.2-2" }} </div>
              </div>

              <div class="hidden-xs mr-4">
                <div class="small text-secondary">{{ 'home.quote.Quantity(WMT)' | cxTranslate }}</div>
                <div class="strong"> {{ quote?.quantity | number :"2.2-2" }} </div>
              </div>
            </div>
            <div class='d-flex'>
              <div class="d-flex">
                <div class="visible-xs">
                  <div id="152" class="small text-secondary">{{ 'home.quote.Vesselname' | cxTranslate }}</div>
                  <div class="strong"> {{ quote?.vesselName}} </div>
                </div>

                <div class="visible-xs ml-5">
                  <div class="small text-secondary">{{ 'home.quote.Voyage' | cxTranslate }}</div>
                  <div class="strong"> {{ quote?.voyageId }} </div>
                </div>

              </div>
              <div class='d-flex'>
                <div class="visible-xs ml-5">
                  <div class="small text-secondary">{{ 'home.quote.Price(perWMT)' | cxTranslate }} </div>
                  <div class="strong"> {{ quote?.price | currency: "RMB ":"symbol":"1.2-2" }} </div>
                </div>
                <div class='visible-xs ml-5'>
                  <div class="small text-secondary">{{ 'home.quote.Quantity(WMT)' | cxTranslate }}</div>
                  <div class="strong"> {{ quote?.quantity | number :"2.2-2" }} </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="quotesData?.quoteEntries[0]?.assignedFeatures != undefined">
            <div class="row quality-alignment pt-3"
              *ngIf="quotesData?.quoteEntries[0]?.assignedFeatures?.entry != undefined">
              <div *ngFor='let a of quotesData.quoteEntries[0].assignedFeatures.entry' class=" col-md-4">
                <div
                  class="small text-secondary pr-3 visible-xs mr-5 d-flex justify-content-between quality-align-width"
                  *ngIf="(a?.key !== 'size lowest') && (a?.key !== 'size max') && (a?.key !== 'qualityId') && (a?.key !== 'other Metal (%)') ">
                  <div>{{a.key}}</div>
                  <div class='semibold'>{{a.value}}%</div>
                </div>
              </div>
            </div>
          </div>
          <div
            *ngIf="quotesData?.quoteEntries[0]?.product?.features != undefined && !quotesData?.quoteEntries[0]?.assignedFeatures">
            <div class="row quality-alignment pt-3"
              *ngIf="quotesData?.quoteEntries[0]?.product?.features?.entry != undefined">
              <div *ngFor='let a of quotesData.quoteEntries[0].product.features.entry' class=" col-md-4">
                <div
                  class="small text-secondary pr-3 visible-xs mr-5 d-flex justify-content-between quality-align-width"
                  *ngIf="(a?.key !== 'size lowest') && (a?.key !== 'size max') && (a?.key !== 'qualityId') && (a?.key !== 'other Metal (%)') ">
                  <div>{{a.key}}</div>
                  <div class='semibold'>{{a?.value}}%</div>
                </div>
              </div>
            </div>
          </div>

          <div class="hr"></div>
          <div class="col-12 col-lg-12 col-md-12 pr-0 pl-0 pt-4">
            <div class="panel-group" id="accordion">
              <div class="panel">
                <div class="panel-heading d-flex justify-content-between " data-toggle="collapse"
                  data-patent="#accordion" data-target="#collapseOne">
                  <div class="strong">{{ 'home.quote.Additional' | cxTranslate }}</div>
                </div>
                <div id="collapseOne" class="panel-collapse collapse show ">
                  <div class="md-font p-3">
                    <p *ngIf="quotesData?.remark!=undefined" class="breaking-line">{{quotesData?.remark}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-12 col-md-12 pr-0 pl-0 pt-4" *ngIf="!quotesData?.tenderId">
            <div class="panel-group" id="accordion">
              <div class="panel ">
                <div class="panel-heading d-flex justify-content-between " data-toggle="collapse"
                  data-target="#collapseTwo">
                  <div class="strong">{{ 'home.quote.Otherterms' | cxTranslate }}</div>
                </div>
                <div id="collapseTwo" class="panel-collapse collapse show">
                  <div class="md-font p-3">
                    <div>

                      <div class="small">
                        {{paymentTerm == ''? '' :paymentTerm}}

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div>
  <div *ngIf="!enableLoader" class="container">
    <div *ngIf="quotesData?.tenderId">
      <!-- <h3  class="extra-lg-font mb-n4 mt-4">
            {{ 'home.quote.Weare' | cxTranslate }}
        </h3> -->
      <div class="desktop-flex justify-content-between">
        <div class="master ml-2">
          <div class="mr-4">
            <span class="small text-secondary">{{ "home.quote.Sellername" | cxTranslate }} </span><br />
            <span class="small strong">{{
              quotesData.c4cCpiSalesOrganization
              ? quotesData.c4cCpiSalesOrganization
              : "--"
              }}</span>
          </div>
          <div class="mr-4" [ngClass]="quotesData.zmasterAgreementSDK != undefined?'':'d-none'">
            <span class="small text-secondary">{{ "home.quote.MasteragreementNo" | cxTranslate }} </span><br />
            <span class="small strong">{{
              quotesData.zmasterAgreementSDK
              ? quotesData.zmasterAgreementSDK
              : "--"
              }}</span>
          </div>
          <div class="mr-4" [ngClass]="quotesData.agreementDate != undefined?'':'d-none'">
            <span class="small text-secondary">{{ "home.quote.Agreementdate" | cxTranslate }} </span><br />
            <span class="small strong">{{
              quotesData.agreementDate
              ? convertDate(quotesData.agreementDate)
              : "--"
              }}</span>
          </div>

        </div>
        <div class=" p-0 mt-4">
          <span class="mr-3"
            *ngIf="quotesData?.quoteStatus == 'Bid placed' && quotesData?.editCancelBidDisplay==true && quotesData?.c4cQuoteExternalQuoteId">
            <button [disabled]="isPlaceBidDisabled" class="btn border1 pl-5 pr-5 btn-mobile-accept" (click)="openmodal('editbid')">
              {{ "tenders.EditBid" | cxTranslate }}
            </button></span>

          <span class="mr-3" *ngIf="quotesData?.quoteStatus == 'Offer received'">
            <button class="btn btn-primary border pl-5 pr-5 btn-mobile-accept" [disabled]="isAcceptOfferDisabled"
              (click)="acceptbid()">
              <i class="fa fa-check"></i> &nbsp;&nbsp;{{'home.quote.Acceptoffer' | cxTranslate }}
            </button></span>

          <span class="mr-3">
            <button
              *ngIf="quotesData?.quoteState=='OFFER_RECEIVED' && quotesData?.c4cQuoteExternalQuoteId && quotesData?.tenderId"
              class="btn btn-secondary border pl-5 pr-5 btn-mobile-transactionDetails" (click)="downloadDesktopEDRPDF()">
              <i class="far fa-file-alt"></i>&nbsp;&nbsp; {{'home.quote.transactionDetails' | cxTranslate }}
            </button>
          </span>
          <span class="mr-3">
            <button
              *ngIf="quotesData?.quoteState=='ACCEPTED' && quotesData?.c4cQuoteExternalQuoteId && quotesData?.tenderId"
              class="btn btn-secondary border pl-5 pr-5 btn-mobile-transactionDetails" (click)="downloadDesktopEDRPDF()">
              <i class="far fa-file-alt"></i>&nbsp;&nbsp; {{'home.quote.transactionDetails' | cxTranslate }}
            </button>
          </span>

        </div>
      </div>
      <br />
      <div>
        <div>
          <div class="card card-design pb-3 pl-3 pr-3 mb-4 card-border border-radius-05">
            <div class="d-flex justify-content-between">
              <div class="d-flex align-items-center">
                <span class="badge badge-secondary" *ngIf="quotesData?.quoteState == 'BID_PLACED'">{{
                  quotesData?.quoteStatus }}
                </span>
                <span class="badge badge-primary" *ngIf="quotesData?.quoteState == 'OFFER_RECEIVED'">{{
                  quotesData?.quoteStatus }}
                </span>
                <span class="badge badge-success" *ngIf="quotesData?.quoteState == 'ACCEPTED'">{{
                  quotesData?.quoteStatus
                  }}
                </span>
                <span id="off333" class="small text-secondary ml-3 visible-xs">{{ "home.quote.validity" | cxTranslate }}
                  {{ quotesData.quoteState ===
                  quoteStatusModel.offerReceived?convertDateAndTime(quotesData.offerValidity,quotesData.offerValidityTimeZone):convertDateAndTime(quotesData.quoteValidity,quotesData.quoteValidityTimeZone)
                  }}
                  {{quotesData.quoteState === quoteStatusModel.offerReceived?quotesData.offerValidityTimeZone?.code:""
                  }}
                  {{quotesData.quoteState !=quoteStatusModel.offerReceived?quotesData.quoteValidityTimeZone?.code:"" }}
                </span>
                <!-- <span class="ml-3 mt-0 text-danger  small" *ngIf="quotesData.quoteState === quoteStatusModel.offerReceived">
                {{expiryCalculate(quotesData.offerValidity)}} </span> -->
              </div>
              <div class="d-flex">
                <span class="small text-secondary visible-xs mr-2">{{ "home.quote.Id" | cxTranslate }}
                  {{
                  quotesData.c4cQuoteExternalQuoteId
                  ? quotesData.c4cQuoteExternalQuoteId
                  : "--"
                  }}</span>
                &nbsp;
                <span class="small text-secondary visible-xs mr-2">
                  {{ "home.quote.Creationdate" | cxTranslate }}
                  {{ convertDate(quotesData.creationTime) }}
                </span>
                <span class="small text-secondary visible-xs">{{ "home.quote.BidPlacedBy" | cxTranslate }}:
                  {{ quotesData?.userName }}</span>
              </div>
            </div>
            <div>
              <div id="358" class="small text-secondary hidden-xs">
                {{ "home.quote.validity" | cxTranslate }}
                {{ quotesData.quoteState ===
                quoteStatusModel.offerReceived?convertDateAndTime(quotesData.offerValidity,quotesData.offerValidityTimeZone):convertDateAndTime(quotesData.quoteValidity,quotesData.quoteValidityTimeZone)
                }}
              </div>
              <div class="small text-secondary hidden-xs mr-5">
                {{ "home.quote.Id" | cxTranslate }} {{ quotesData.c4cQuoteExternalQuoteId }}
              </div>
              <div class="small text-secondary hidden-xs">
                {{ "home.quote.Creationdate" | cxTranslate }}
                {{ convertDate(quotesData.creationTime) }}
              </div>
            </div>
            <div class="hr"></div>
            <div class="row pt-2" *ngFor="let quote of quotesData.combinedTenders; let i = index">
              <div class="col-10 col-md-5 pb-2">
                <div class="small text-secondary small" *ngIf="quotesData?.quoteEntries?.length > 1">
                  {{ "home.headerLinks.material" | cxTranslate }} #{{ i + 1 }}
                </div>
                <div class="h5 mb-2 fw-bold">
                  {{ quote.newName?quote.newName:quote.productName | titlecase }}
                </div>
                <div *ngIf="quotesData?.commodityType != 'CN'">
                  <div class="mb-0 lg-font mb-0 text-secondary" *ngFor="let row of quote?.pricingOptionsEnum">
                    {{row.pricingOptionsValue}}</div>
                </div>
                <div *ngFor="let child of quote?.childList;let j=index">
                  <div class="d-flex justify-content-between mt-2"
                    *ngIf="quote?.pricingOptionsEnum[0]?.pricingOptions=='FIXED_PRICE' && quotesData?.commodityType!= 'CN'">
                    <div class="small">
                      <div class="small text-secondary">{{child.productName}} {{'tenders.priceLabel'| cxTranslate}} (per
                        {{quote.displayFixedPriceConfig?.displayFixedPriceUnitDesc}})</div>
                      <div class="small strong">USD {{child?.relativePrice?.value}}</div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between mt-2"
                    *ngIf="(quote?.pricingOptionsEnum[0]?.pricingOptions=='INDEX_PRICE' || quote?.pricingOptionsEnum[1]?.pricingOptions=='LUMP_FIXED_PRICE' ) && quotesData?.commodityType!= 'CN'">
                    <div class="small">
                      <div class="small text-secondary" *ngIf="quotesData?.commodityType== 'CC'">{{child.productName}}
                        {{'tenders.priceLabel'| cxTranslate}}
                      </div>
                      <div class="small text-secondary" *ngIf="quotesData?.commodityType== 'IO' && (quote.pricingOptionsEnum[0]?.pricingOptions=='INDEX_PRICE' 
                        || quote.pricingOptionsEnum[1].pricingOptions=='INDEX_PRICE' )">{{child.productName}} (per
                        {{quote.displayIndexPriceConfig.displayIndexPriceUnitDesc}})</div>
                      <div class="small text-secondary" *ngIf="quotesData?.commodityType== 'IO' &&(quote.pricingOptionsEnum[1]?.pricingOptions=='LUMP_FIXED_PRICE' 
                            || quote.pricingOptionsEnum[2]?.pricingOptions=='LUMP_FIXED_PRICE' )">{{child.productName}}
                        (per
                        {{quote.displayLumpFixedPriceConfig.displayLumpFixedPriceUnitDesc}})</div>
                      <div class="small strong">{{child?.premiumDiscount?.value}} %</div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between mt-2" *ngIf="quotesData?.commodityType== 'CN'">
                    <div class="small">
                      <div class="small text-secondary  small price-wrap">{{child.productName}} TC (per
                        {{child.displayTCPriceUnitDesc}})
                      </div>
                      <div class="strong small">USD {{child.tcPrice?.value || '0'}}</div>
                    </div>
                    <div class="small" *ngIf="quote?.displayRCPrice == true">
                      <div class="small text-secondary wrap">{{child.productName}} RC (per
                        {{child.displayRCPriceUnitDesc}} of payable Copper)</div>
                      <div class="strong small">USD {{child.rcPrice?.value|| '0'}}</div>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="mt-4 mb-2"
                    *ngIf="((quote?.pricingOptionsEnum[0]?.pricingOptions =='INDEX_PRICE')|| (quote?.pricingOptionsEnum[0]?.pricingOptions == 'LUMP_FIXED_PRICE') || quotesData?.commodityType == 'CA') && (quotesData?.commodityType != 'CN')">
                    <div *ngIf="quotesData?.commodityType != 'CA'" class="small text-secondary small">
                      {{ "tenders.Pricingbasis" | cxTranslate }}
                    </div>
                    <div *ngIf="quotesData?.commodityType == 'CA'" class="small text-secondary small">
                      {{ "tenders.Pricelabel" | cxTranslate }}
                    </div>
                    <div class="small" *ngFor="let pricingBase of quote.pricingBasis">
                      {{
                      getPricingBasisBasedOnOption(quote?.pricingOptionsEnum[0]?.pricingOptions,pricingBase.description)
                      }}
                    </div>
                  </div>
                  <div class="mb-2"
                    *ngIf="(quote?.pricingOptionsEnum[0]?.pricingOptions =='INDEX_PRICE')|| (quote?.pricingOptionsEnum[0]?.pricingOptions == 'LUMP_FIXED_PRICE') || quotesData?.commodityType == 'CA'">

                    <div *ngIf="quote.baseKOP == 'BA CU'" class="small text-secondary">{{'tenders.QuotationPeriodCU'|
                      cxTranslate}} </div>
                    <div *ngIf="quote.baseKOP == 'BA ZN'" class="small text-secondary">{{'tenders.QuotationPeriodZN'|
                      cxTranslate}}</div>
                    <div *ngIf="quote.baseKOP != 'BA CU' && quote.baseKOP != 'BA ZN'" class="small text-secondary">
                      {{'tenders.QuotationPeriod'| cxTranslate}}</div>
                    <div class="small">
                      {{formatQPDates(quote)}}
                    </div>
                  </div>
                  <div class="mb-2" *ngFor="let options of quote?.pricingOptionsEnum">
                    <div *ngIf="options?.premiumIndex != '' && options?.premiumIndex!=undefined">
                      <div class="mt-2 small text-secondary">{{"tenders.Premiumlabel" | cxTranslate}}</div>
                      <div class="small text-black">
                        {{options.premiumIndex}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-2" *ngIf="quotesData?.commodityType != 'CN'">
                  <div class="small text-secondary small">
                    {{ "tenders.LoadPort" | cxTranslate }}
                  </div>

                  <div class="small">
                    {{ quote.defaultLoadPort ? quote.defaultLoadPort : "--" }}
                  </div>
                </div>
                <div class=" mb-2" *ngIf="quotesData?.incoterms!='FOB'">
                  <div class="small text-secondary ">{{'tenders.DischargePort'| cxTranslate}}</div>
                  <div class="small">{{quote.dischargePortDetails?quote.dischargePortDetails:'--'}}</div>
                </div>
              </div>

              <div *ngIf=" quote?.childList==undefined">
                <ng-container *ngFor="let options of quote?.pricingOptionsEnum">
                  <div class="col-md-12 hidden-xs" *ngIf="quotesData?.commodityType != 'CN'">
                    <div class="small text-secondary">
                      {{getLabelofConfirmScreen(options,quotesData?.commodityType,'details')}}
                    </div>
                    <div class="strong">
                      {{getPriceandSymbol(options,quote,quotesData?.commodityType)}}
                    </div>
                  </div>
                  <div id="549" class="hidden-xs"
                    [ngClass]="quotesData?.commodityType == 'CN' &&quote?.tcPrice && quote?.rcPrice ? 'col-md-6' : ''"
                    *ngIf="quotesData?.commodityType == 'CN' &&quote?.tcPrice">
                    <!-- <div class="visible-xs col-md-6" *ngIf="quotesData?.commodityType == 'CN' &&quote?.tcPrice"> -->
                    <div class="small text-secondary">
                      TC (per {{ quote.displayTCPriceConfig?.displayTCPriceUnitDesc }})
                    </div>
                    <div class="strong">USD {{ quote?.tcPrice?.value }}</div>
                  </div>
                  <div class="col-md-10 hidden-xs" *ngIf="quotesData?.commodityType == 'CN' && quote?.rcPrice">
                    <div class="small text-secondary">
                      RC (per {{ quote.displayRCPriceConfig?.displayRCPriceUnitDesc }} of payable
                      Copper)
                    </div>
                    <div class="strong">USD {{ quote?.rcPrice?.value }}</div>
                  </div>
                </ng-container>
                <div class="col hidden-xs mr-4">
                  <div class="small text-secondary">
                    {{ "tenders.Quantity(DMT)" | cxTranslate }}({{
                    quote.displayQuantityUnitDesc
                    }})
                  </div>
                  <div class="strong">{{ quote.quantity | number }}</div>
                </div>
                <!-- </div> -->
                <div class="col-md-12">
                  <div class="col d-flex">
                    <ng-container *ngFor="let options of quote?.pricingOptionsEnum">
                      <div class="col-md-12 visible-xs" *ngIf="quotesData?.commodityType != 'CN'">
                        <div class="small text-secondary">
                          {{getLabelofConfirmScreen(options,quotesData?.commodityType,'details')}}
                        </div>
                        <div class="strong">
                          {{getPriceandSymbol(options,quote,quotesData?.commodityType)}}
                        </div>
                      </div>
                      <div id="549" class="visible-xs"
                        [ngClass]="quotesData?.commodityType == 'CN' &&quote?.tcPrice && quote?.rcPrice ? 'col-md-6' : ''"
                        *ngIf="quotesData?.commodityType == 'CN' &&quote?.tcPrice">
                        <!-- <div class="visible-xs col-md-6" *ngIf="quotesData?.commodityType == 'CN' &&quote?.tcPrice"> -->
                        <div class="small text-secondary">
                          TC (per {{ quote.displayTCPriceConfig?.displayTCPriceUnitDesc }})
                        </div>
                        <div class="strong">USD {{ quote?.tcPrice?.value }}</div>
                      </div>
                      <div class="col-md-10 visible-xs" *ngIf="quotesData?.commodityType == 'CN' && quote?.rcPrice">
                        <div class="small text-secondary">
                          RC (per {{ quote.displayRCPriceConfig?.displayRCPriceUnitDesc }} of payable
                          Copper)
                        </div>
                        <div class="strong">USD {{ quote?.rcPrice?.value }}</div>
                      </div>
                    </ng-container>
                   
                  </div>
                </div>
              </div>
              <div class="col-md-2 visible-xs">
                <div class="small text-secondary">
                  {{ "tenders.Quantity(DMT)" | cxTranslate }}({{
                  quote.displayQuantityUnitDesc
                  }})
                </div>
                <div class="strong">{{ quote.quantity | number }}</div>
              </div>
              <div class="col-md-2 visible-xs">
                <div class="small text-secondary"
                  *ngIf="quotesData?.commodityType == 'CN'&& quotesData.arrivalPeriod == 'false'">
                  {{ "tenders.Deliveryperiod" | cxTranslate }}
                </div>
                <div class="small text-secondary" *ngIf="quotesData?.arrivalPeriod == 'true'">
                  {{ "tenders.ArrivalPeriod" | cxTranslate }}
                </div>
                <div class="small text-secondary"
                  *ngIf="(quotesData?.commodityType == 'CC'|| quotesData?.commodityType == 'IO') && quotesData.arrivalPeriod == 'false'">
                  {{ "tenders.LoadPortLaycan" | cxTranslate }}
                </div>
                <div class="small text-secondary"
                  *ngIf="(quotesData?.commodityType == 'CA') && quotesData.arrivalPeriod == 'false'">
                  {{ "tenders.schedule" | cxTranslate }}
                </div>
                <div *ngIf="quotesData?.arrivalPeriod == 'false'" class="strong">
                  {{ quote.laycanStartDate | date : "dd/MM/yyyy" }} - {{ quote.laycanEndDate | date : "dd/MM/yyyy" }}
                </div>
                <div *ngIf="quotesData?.arrivalPeriod == 'true'" class="strong">
                  {{ quotesData.arrivalStartDate | date : "dd/MM/yyyy" }} - {{ quotesData.arrivalEndDate | date :
                  "dd/MM/yyyy" }}
                </div>
              </div>
              <div class="hr mx-3"></div>
            </div>
            <div class="col-12 col-lg-12 col-md-12 pr-0 pl-0 pt-4"
              *ngIf="quotesData?.quoteState != 'OFFER_RECEIVED' && quotesData.quoteState != 'ACCEPTED' && quotesData.commodityType != 'IO'">
              <div class="panel-group" id="accordion">
                <div class="panel">
                  <div class="panel-heading d-flex justify-content-between" data-toggle="collapse"
                    data-patent="#accordion" data-target="#collapseOne">
                    <div class="strong">
                      {{ "home.quote.BuyerRemarks" | cxTranslate }}
                    </div>
                  </div>
                  <div id="collapseOne" class="panel-collapse collapse show">
                    <div class="md-font p-3">
                      <p class="breaking-line">
                        {{ quotesData.buyerRemarks }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-12 col-md-12 pr-0 pl-0 pt-4">
              <div class="panel-group" id="accordion">
                <div class="panel">
                  <div class="panel-heading d-flex justify-content-between" data-toggle="collapse"
                    data-target="#collapseTwo" (click)="otherTerms = !otherTerms">
                    <div class="strong">
                      {{ "home.quote.Otherterms" | cxTranslate }}
                    </div>
                  </div>
                  <div id="collapseTwo" class="panel-collapse collapse show">
                    <div class="md-font p-3">
                      <div>
                        <div class="small">
                          <!--open negotiation page-->
                          <div class="row">
                            <div class="col-md">
                              <!-- <div class="mb-2">
                                                            <div class="small text-secondary small">{{'tenders.LoadPort'| cxTranslate}}</div>
                                                            <div class="small">{{loadport?loadport:''}}</div>
                                                        </div> -->
                              <div class="mb-2">
                                <div class="small text-secondary small">
                                  {{
                                  "tenders.ShippingTolerance" | cxTranslate
                                  }}
                                </div>
                                <div class="small">
                                  {{ quotesData.shippingTolerance }}
                                </div>
                              </div>
                              <div class="mb-2">
                                <div class="small text-secondary small">
                                  {{ "tenders.Incoterms" | cxTranslate }}
                                </div>
                                <div class="small">
                                  {{ quotesData.incoterms }}
                                </div>
                              </div>
                              <div class="mb-2">
                                <div class="small text-secondary small">
                                  {{
                                  "tenders.TermsAndconditions" | cxTranslate
                                  }}
                                </div>
                                <div class="small">
                                  {{ quotesData?.termsAndConditions?.description }}
                                </div>
                              </div>
                              <div
                                *ngIf="quotesData?.commodityType=='CC' && (quotesData?.quoteStatus=='Accepted' || quotesData?.quoteStatus== 'Offer received')"
                                class="mb-2">
                                <div class="small text-secondary small">
                                  {{
                                  "tenders.OfferType" | cxTranslate
                                  }}
                                </div>
                                <div *ngIf="quotesData?.conditionalOffer == true" class="small">
                                  This offer is Conditional, subject to BHP internal approval'
                                </div>
                                <div *ngIf="quotesData?.conditionalOffer == false" class="small">
                                  This offer is Unconditional
                                </div>
                              </div>
                              <!-- <div class="mb-2">
                                                            <div class="small text-secondary small">{{'tenders.Pricingbasis'|cxTranslate}}</div>
                                                            <div class="small" *ngFor="let pricingBase of quotesData.pricingBase">{{pricingBase?pricingBase:'--'}}</div>
                                                        </div>
                                                        <div class="mb-2">
                                                            <div class="small text-secondary small">{{'tenders.Pricingquotation'|cxTranslate}}</div>
                                                            <div class="small">{{quotesData.qp?quotesData.qp:'--'}}</div>
                                                        </div> -->
                              <div class="mb-2">
                                <div class="small text-secondary small" *ngIf="quotesData.demurrageRate!=undefined">
                                  {{ "tenders.DemurrageRate" | cxTranslate }}
                                </div>
                                <div class="small wrap">
                                  {{ quotesData?.demurrageRate }}
                                </div>
                              </div>
                              <div class="mb-2">
                                <div class="small text-secondary small" *ngIf="quotesData.despatchRate!=undefined">
                                  {{ "tenders.DespatchRate" | cxTranslate }}
                                </div>
                                <div class="small mb-3">
                                  {{ quotesData?.despatchRate }}
                                </div>
                              </div>
                              <div [ngClass]="quotesData.remark !== undefined?'':'d-none'">
                                <div class="mb-2">
                                  <div class="small text-secondary small">
                                    {{ "tenders.SellerRemarks" | cxTranslate }}
                                  </div>
                                  <div class="small col-lg-6 pl-0 sellerRemarkHighlight">
                                    {{
                                    quotesData.remark
                                    ? quotesData.remark
                                    : "--"
                                    }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col ml-1">
                              <div class="d-flex flex-column">
                                <div class="small text-secondary small">
                                  {{ "tenders.Attachment" | cxTranslate }}
                                </div>
                                <div *ngIf="!bidAttachments">
                                  <div *ngFor="
                                      let docs of quotesData?.attachments;
                                      let i = index
                                    ">
                                    <img src="/images/attachment.svg" alt="icon" width="9" height="17" /><a
                                      class="ml-1 mb-0 strong shadow-none" href="{{ docs.downloadURL }}"
                                      target="_blank"><span class="small ml-1 mb-2 strong text-primary">{{
                                        docs?.documentName
                                        ? docs?.documentName
                                        : "--"
                                        }}</span></a>
                                  </div>
                                </div>
                                <div *ngIf="bidAttachments && bidAttachments!=''">
                                  <div *ngFor="let key of objectKeys(bidAttachments)">
                                    <img src="/images/attachment.svg" alt="icon" width="9" height="17" /><a
                                      class="ml-1 mb-0 strong shadow-none" target="_blank"><span
                                        class="small ml-1 mb-2 strong text-primary"
                                        (click)="bidAttachment(bidAttachments[key],$event)">{{key? key:
                                        "--"}}</span></a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container" *ngIf="!enableLoader && quotesData?.commodityType=='PO'">
      <div class="desktop-flex justify-content-between pb-3">
        <div class="master ml-2">
          <div class="mr-4">
            <span class="small text-secondary">{{ "home.quote.Sellername" | cxTranslate }} </span><br />
            <span class="small strong">{{
              quotesData.c4cCpiSalesOrganization
              ? quotesData.c4cCpiSalesOrganization
              : "--"
              }}</span>
          </div>
          <div class="mr-3" [ngClass]="quotesData.zmasterAgreementSDK !== undefined?'':'d-none'">
            <span class='small text-secondary'>{{ 'home.quote.MasteragreementNo' | cxTranslate }} </span><br>
            <span class="strong">{{quotesData.zmasterAgreementSDK !== undefined?quotesData.zmasterAgreementSDK:''
              }}</span>
          </div>
          <div [ngClass]="quotesData.agreementDate !== undefined?'':'d-none'">
            <span class='small text-secondary'>{{ 'home.quote.Agreementdate' | cxTranslate }} </span><br>
            <span class="strong">{{quotesData.agreementDate !==undefined?convertDate(quotesData.agreementDate):''}}</span>
          </div>
        </div>
        <div class="d-flex p-0 mt-4">
          <!-- <span class="mr-3">
            <button *ngIf="quotesData?.quoteStatus == 'Order placed'  && quotesData?.c4cQuoteExternalQuoteId" [disabled]="isPlaceBidDisabled" class="btn border pl-5 pr-5 w-100" (click)="editOrder(quotesData)">
              Edit order
            </button></span> -->
          <span class="mr-3">
            <button [disabled]="isPlaceBidDisabled" *ngIf="quotesData?.quoteStatus == 'Order placed'  && quotesData?.c4cQuoteExternalQuoteId" class="btn border pl-5 pr-5 w-100" (click)="openCancelModal(quotesData,'order')">
              Cancel order
            </button></span>

        <div class="desktop-flex">
          <div *ngIf="quotesData?.quoteState=='OFFER_RECEIVED'" class=""><button
              class="btn btn-primary btn-mobile-accept" [disabled]="isAcceptOfferDisabled"
              (click)="openAcceptModal(quotesData)"> <i class="fa fa-check text-white pr-2" aria-hidden="true"></i>
              {{'home.quote.Acceptoffer' | cxTranslate }} </button>
          </div>
          <div class="space d-flex ml-lg-1">
            <div *ngIf="quotesData?.quoteState=='OFFER_RECEIVED'" class='mobile-btn-reject'> <button
                [disabled]="isPlaceBidDisabled" class="btn btn-secondary left mobile-w-100 fw-bold"
                (click)="openRejectModal(quotesData)">
                <i class="fas fa-times text-white pr-2"></i><a class="anchor-tag text-white">{{ 'home.quote.Rejectoffer'
                  |cxTranslate }}</a></button></div>
          </div>
        </div>
        </div>
      </div>
    <div class="card card-design pb-3 pl-3 pr-3 mb-4 card-border border-radius-05">
            <div class="d-flex justify-content-between">
              <div class="d-flex align-items-center">
                <span class="badge badge-secondary" *ngIf="quotesData?.quoteState == 'BID_PLACED'">{{
                  quotesData?.quoteStatus }}
                </span>
                <span class="badge badge-primary" *ngIf="quotesData?.quoteState == 'OFFER_RECEIVED'">{{
                  quotesData?.quoteStatus }}
                </span>
                <span class="badge badge-success" *ngIf="quotesData?.quoteState == 'ACCEPTED'">{{
                  quotesData?.quoteStatus
                  }}
                </span>
                 <!-- <span id="off333" class="small text-secondary ml-3 visible-xs">{{ "home.quote.validity" | cxTranslate }}
                 {{ quotesData.quoteState ===
                quoteStatusModel.offerReceived?convertDateAndTime(quotesData.offerValidity,quotesData.offerValidityTimeZone):convertDateAndTime(quotesData.quoteValidity,quotesData.quoteValidityTimeZone)
                }}
                </span>  -->
              </div>
              <div class="d-flex">
                <span class="small text-secondary visible-xs mr-2">{{ "home.quote.Id" | cxTranslate }}
                  {{
                  quotesData.c4cQuoteExternalQuoteId
                  ? quotesData.c4cQuoteExternalQuoteId
                  : "--"
                  }}</span>
                &nbsp;
                <span class="small text-secondary visible-xs mr-2">
                  {{ "home.quote.Creationdate" | cxTranslate }}
                  {{ convertDate(quotesData.creationTime) }}
                </span>
                <span class="small text-secondary visible-xs">Order placed by:
                  {{ quotesData?.userName }}</span>
              </div>
            </div>
            <div>
              <div id="358" class="small text-secondary hidden-xs">
                {{ "home.quote.validity" | cxTranslate }}
                {{ quotesData.quoteState ===
                quoteStatusModel.offerReceived?convertDateAndTime(quotesData.offerValidity,quotesData.offerValidityTimeZone):convertDateAndTime(quotesData.quoteValidity,quotesData.quoteValidityTimeZone)
                }}
              </div>
              <div class="small text-secondary hidden-xs mr-5">
                {{ "home.quote.Id" | cxTranslate }} {{ quotesData.c4cQuoteExternalQuoteId }}
              </div>
              <div class="small text-secondary hidden-xs">
                {{ "home.quote.Creationdate" | cxTranslate }}
                {{ convertDate(quotesData.creationTime) }}
              </div>
            </div>
            <div class="hr"></div>

<div class="row pb-3">
    <div class="col-md-3">
      <div class="h5 mb-0 fw-bold">
        {{quotesData?.quoteEntries[0]?.productName}}
      </div>  
    </div>
    <div class="col-md-2">
      <div class="text-secondary">
        Quantity (ST)
      </div>
       <div class="strong" *ngIf="quotesData?.allowedDecimalQty==0">
        {{quotesData?.quoteEntries[0]?.quantityInDecimal|number:'1.0-0'}}
      </div>
      <div class="strong" *ngIf="quotesData?.allowedDecimalQty>0">
        {{quotesData?.quoteEntries[0]?.quantityInDecimal|number:'1.3-3'}}
      </div>
  
    </div>
    <div class="col-md-1">
      <div class="text-secondary">
        Base price
      </div>
      <div class="strong">
        {{quotesData?.quoteEntries[0]?.basePriceValue }}
      </div>
  
    </div>
    <div class="col-md-2">
      <div class="text-secondary">
        Order Date
      </div>
      <div class="strong">
        {{quotesData?.quoteEntries[0]?.deliveryStartDate | date:'dd/MM/yyyy'}}
      </div>
  
    </div>
        <div class="col-md-2">
      <div class="text-secondary">
       External reference no
      </div>
      <div class="strong">
        {{quotesData?.externalRefNo ? quotesData?.externalRefNo : '--'}}
      </div>
  
    </div>

      <div class="col-md-2">
      <div class="text-secondary">
        Location
      </div>
      <div class="strong">
        {{quotesData?.quoteEntries[0]?.locationName }} {{quotesData?.address.houseNum}}
                    {{quotesData?.address?.street}} {{quotesData?.address?.city}}
                    / {{quotesData?.address?.state}}
                    {{quotesData?.address?.country}} {{quotesData?.address?.pin}}
      </div>
  
    </div>

  
  </div>
  <div class="row">
    <ng-container *ngFor="let price of quotesData?.quoteEntries[0]?.priceList">
    <div  class="col-md-2 col pb-3" *ngIf="price.kopCode!=='BASE'">
        <div class="small text-secondary">{{ price.kopName }}</div>
        <div class="strong" *ngIf="!price.kopPricePercentage||price.kopPricePercentage==0">
          ${{price.kopPriceAmount|number:'1.2-2'}}
          </div>
          <div class="strong" *ngIf="price.kopPricePercentage && price.kopPricePercentage!=0">
          {{price.kopPricePercentage|number:'1.2-2'}}%
          </div>
    </div>
  </ng-container>
  </div>
            <div class="hr"></div>
            <div class="col-12 col-lg-12 col-md-12 pr-0 pl-0 pt-4" *ngIf="quotesData?.quoteState != 'OFFER_RECEIVED' && quotesData.quoteState != 'ACCEPTED'"
              >
              <div class="panel-group" id="accordion">
                <div class="panel">
                  <div class="panel-heading d-flex justify-content-between" data-toggle="collapse"
                    data-patent="#accordion" data-target="#collapseOne">
                    <div class="strong">
                      {{ "home.quote.BuyerRemarks" | cxTranslate }}
                    </div>
                  </div>
                  <div id="collapseOne" class="panel-collapse collapse show">
                    <div class="md-font p-3">
                      <p class="breaking-line">
                        {{ quotesData.buyerRemarks }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-12 col-md-12 pr-0 pl-0 pt-4">
              <div class="panel-group" id="accordion">
                <div class="panel">
                  <div class="panel-heading d-flex justify-content-between" data-toggle="collapse"
                    data-target="#collapseTwo" (click)="otherTerms = !otherTerms">
                    <div class="strong">
                      {{ "home.quote.Otherterms" | cxTranslate }}
                    </div>
                  </div>
                  <div id="collapseTwo" class="panel-collapse collapse show">
                    <div class="md-font p-3">
                      <div>
                        <div class="small">
                          <div class="row">
                             <div class="col-md">
                              <!-- <div class="mb-2">
                                <div class="small text-secondary small">
                                  {{
                                  "tenders.ShippingTolerance" | cxTranslate
                                  }}
                                </div>
                                <div class="small">
                                  {{ quotesData.shippingTolerance?quotesData.shippingTolerance:'--' }}
                                </div>
                              </div> -->
                              <div class="mb-2">
                                <div class="small text-secondary small">
                                  {{ "tenders.Incoterms" | cxTranslate }}
                                </div>
                                <div class="small">
                                  {{ quotesData.incoterms?quotesData.incoterms:'--' }}
                                </div>
                              </div>
                              <div class="mb-2">
                                <div class="small text-secondary small">
                                  {{
                                  "tenders.TermsAndconditions" | cxTranslate
                                  }}
                                </div>
                                <div class="small">
                                  {{ quotesData?.termsAndConditions?.description }}
                                </div>
                              </div>
                              <div class="mb-2">
                                <div class="small text-secondary small" *ngIf="quotesData.demurrageRate!=undefined">
                                  {{ "tenders.DemurrageRate" | cxTranslate }}
                                </div>
                                <div class="small wrap">
                                  {{ quotesData?.demurrageRate?quotesData?.demurrageRate:'--' }}
                                </div>
                              </div>
                              <!-- <div class="mb-2">
                                <div class="small text-secondary small" *ngIf="quotesData.despatchRate!=undefined">
                                  {{ "tenders.DespatchRate" | cxTranslate }}
                                </div>
                                <div class="small mb-3">
                                  {{ quotesData?.despatchRate }}
                                </div>
                              </div> -->
                              <div [ngClass]="quotesData.remark !== undefined?'':'d-none'">
                                <div class="mb-2">
                                  <div class="small text-secondary small">
                                    {{ "tenders.SellerRemarks" | cxTranslate }}
                                  </div>
                                  <div class="small col-lg-6 pl-0 sellerRemarkHighlight">
                                    {{
                                    quotesData.remark
                                    ? quotesData.remark
                                    : "--"
                                    }}
                                  </div>
                                </div>
                              </div>
                            </div>
                                                        <div class="col ml-1">
                              <div class="d-flex flex-column">
                                <div class="small text-secondary small">
                                  {{ "tenders.Attachment" | cxTranslate }}
                                </div>
                                <div *ngIf="!bidAttachments">
                                  <div *ngFor="
                                      let docs of quotesData?.attachments;
                                      let i = index
                                    ">
                                    <img src="/images/attachment.svg" alt="icon" width="9" height="17" /><a
                                      class="ml-1 mb-0 strong shadow-none" href="{{ docs.downloadURL }}"
                                      target="_blank"><span class="small ml-1 mb-2 strong text-primary">{{
                                        docs?.documentName
                                        ? docs?.documentName
                                        : "--"
                                        }}</span></a>
                                  </div>
                                </div>
                                <div *ngIf="bidAttachments && bidAttachments!=''">
                                  <div *ngFor="let key of objectKeys(bidAttachments)">
                                    <img src="/images/attachment.svg" alt="icon" width="9" height="17" /><a
                                      class="ml-1 mb-0 strong shadow-none" target="_blank"><span
                                        class="small ml-1 mb-2 strong text-primary"
                                        (click)="bidAttachment(bidAttachments[key],$event)">{{key? key:
                                        "--"}}</span></a>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

    </div>
    

  </div>
  
  <br /><br />

  <!-- modal -->
  <app-accept-bid-modal #acceptModal> </app-accept-bid-modal>
  <!-- <app-cancel-bid-modal #cancelModal> </app-cancel-bid-modal> -->
  <app-counter-offer-modal #counterOfferModal [modalConfig]="modalConfig">
  </app-counter-offer-modal>
  <app-reject-bid-modal #rejectModal> </app-reject-bid-modal>
</div>